<template>
  <div class="white-content-table">
    <div
      class="table-responsive"
      @change="consultar"
    >
      <table class="table table-stripped">
        <thead>
          <tr>
            <th width="5%"></th>
            <th>Nombre</th>
            <th>Usuario</th>
            <th>Rol</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in solicitudes"
            :key="item.id"
            @change="consultar"
          >
            <td>
              <a
                href="javascript:void(0)"
                @click="revisar(item)"
              >
                <i class="ti-eye btn-icon-append"></i> </a
              >&nbsp;
            </td>
            <td>{{ item.nombre }}</td>
            <td>{{ item.usuario }}</td>
            <td>{{ item.rol }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  name: 'GestionSolicitudRegistro',
  data() {
    return {};
  },
  created() {
    this.consultar();
  },
  methods: {
    loaderSpinner() {
      this.loader = this.$loading.show();
    },
    async consultar() {
      this.loaderSpinner();
      try {
        await this.$store.dispatch('solicitudRegistro/consultar');
      } catch (error) {
        this.$swal({
          text: 'Error al consultar las solicitudes de registro',
          icon: 'error',
        });
      } finally {
        this.loader.hide();
      }
    },
    async revisar(item) {
      await this.$store.commit('solicitudRegistro/setSolicitudSeleccionada', item);
      this.$router.push({ name: 'SolicitudRegistroForm' });
    },
  },
  computed: {
    solicitudes() {
      return this.$store.getters['solicitudRegistro/solicitudes']
        ? this.$store.getters['solicitudRegistro/solicitudes']
        : [];
    },
    isLogged() {
      return this.$store.getters['auth/isLogged'] ? this.$store.getters['auth/isLogged'] : false;
    },
  },
};
</script>
